import React from 'react';
import type { FC } from 'react';

interface LogoProps {
  [key: string]: any;
}

const LogoDark: FC<LogoProps> = (props) => {
  return (
    <img
      alt="Arupo Legaltech Innovation Hub Logo"
      title="Arupo Legaltech Innovation Hub Logo"
      src="/static/dark_logo.svg"
      {...props}
    />
  );
}

export default LogoDark;
